package org.testadirapa.cardtraderscout

import org.jetbrains.compose.web.renderComposable

fun main() {
	renderComposable("root") {
		App()
	}
}